import { render, staticRenderFns } from "./UberMenuCopy.vue?vue&type=template&id=028df7ae&scoped=true"
import script from "./UberMenuCopy.vue?vue&type=script&lang=js"
export * from "./UberMenuCopy.vue?vue&type=script&lang=js"
import style0 from "./UberMenuCopy.vue?vue&type=style&index=0&id=028df7ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "028df7ae",
  null
  
)

export default component.exports